import Reflux from "reflux";

import Chip from "@reactComponents/lds/chips/Chip";
import { FacetSearchCompanyRelationshipActions } from "@javascript/stores/actions/facetSearch/companyRelationshipActions";
import FacetSearchStore from "@javascript/stores/facetSearchStore";

const FacetSearchCriteriaMutedCompany = createReactClass({
  mixins: [Reflux.connectFilter(FacetSearchStore,"selected", function(data){
    return data.relationships.selected
  })],

  render(){
    const selected = this.state.selected;

    const relationshipsSelected = _.sortBy(selected, (rel) => -rel.length);
    const lastRelationshipSelected = relationshipsSelected.length -1;
    const relationshipProps =  relationshipsSelected.map((relationship, index) => {
      return {
        name: Zymewire.relationship_properties[relationship],
        value: relationship,
        last: lastRelationshipSelected === index,
      }
    });

    let mutedCompanyList = null;

    if(relationshipProps.length > 0) {
      _.each(relationshipProps, function (prop) {
        if (prop.value === "exclude_muted_companies") {
          mutedCompanyList = prop;
        }
      });
    }

    if(!mutedCompanyList){
      return null;
    }

    let original = Zymewire.original_feed_query;

    let neededValuesPresent = original && original.relationships && original.relationships.length > 0;

    if(neededValuesPresent){
      mutedCompanyList.locked = _.contains(original.relationships, mutedCompanyList.value);
      $('.relationships-accordion').hide();
    }

    return (
      <MutedCompaniesAppliedFilterEntry
        listName={mutedCompanyList.name}
        listValue={mutedCompanyList.value}
        locked={mutedCompanyList.locked}
      />
    );
  }
});

const MutedCompaniesAppliedFilterEntry = ({ listName, listValue, locked}) => {

  let removeList = () => {
    FacetSearchCompanyRelationshipActions.removeCompanyRelationship(listValue);
    return false;
  };

  return (
    <Chip
      className="search_filter_applied_chip"
      label={`${Zymewire.facet_search_filters.company_relationship}: ${listName}`}
      leadingIcon="company_relationship"
      size="small"
      {...!locked && {
        trailingIcon: "cancel",
        trailingIconClassName: "search_filter_applied_trailing_icon",
        trailingIconOnClick: removeList,
      }}
      variant="secondary"
    />
  );
}

window.FacetSearchCriteriaMutedCompany = FacetSearchCriteriaMutedCompany;
export default FacetSearchCriteriaMutedCompany;
